import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { MedicalOrderOperation } from "src/app/model/medical-order-operation";
import { IntegratedAdmissionService } from "src/app/services/integrated-admission/integrated-admission.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";

@Component({
  selector: "app-integrated-admission-operation-dialog",
  templateUrl: "./integrated-admission-operation-dialog.component.html",
  styleUrls: ["./integrated-admission-operation-dialog.component.css"],
})
export class IntegratedAdmissionOperationDialogComponent implements OnInit {
  form: FormGroup;
  returnurl: string;
  atention: string;
  loading: boolean;
  laoded: boolean;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: string,
    public dialogRef: MatDialogRef<IntegratedAdmissionOperationDialogComponent>,
    private notificationToastService: NotificationToastService,
    private integratedAdmissionService: IntegratedAdmissionService
  ) {
    this.form = this.formBuilder.group({
      MedicalOrderOperation: [null],
    });
  }

  async ngOnInit() {
    try {
      const ids =
        await this.integratedAdmissionService.getMedicalAppointmentIdsByAtention(
          this.data
        );

      const medicalOrderOperation = new MedicalOrderOperation();
      medicalOrderOperation.MedicalApponitmentIds = ids;
      medicalOrderOperation.MedicalApponitmentId = ids[0];

      this.form.patchValue({
        MedicalOrderOperation: medicalOrderOperation,
      });
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.laoded = true;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
